import React from 'react'
import { Box, Typography } from '@mui/material'
import Layout from '../components/Layout/Layout'
import PoolList from '../components/Pool/PoolList'
import { usePool } from '../contexts/PoolContext'
import usePageTracking from '../hooks/usePageTracking'

const PoolManagement = () => {
  usePageTracking('Pool Management');

  const { selectedPool, setSelectedPool } = usePool()

  const handlePoolSelect = (pool) => {
    setSelectedPool(pool)
  }

  return (
    <Layout>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Box>
          <Typography variant="h4" component="h2" sx={{ fontWeight: 700 }}>
            Pool Management
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Create and manage your pools
          </Typography>
        </Box>

        <PoolList selectedPool={selectedPool} onPoolSelect={handlePoolSelect} />
      </Box>
    </Layout>
  )
}

export default PoolManagement
